import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import type { Content } from '@plone/types';
import type { BlockWrapperDataProps } from '../BlockWrapper/BlockWrapper';
import { BlockWrapper } from '../BlockWrapper/BlockWrapper';
import { Distributor } from '@designsystem/stories/04-organisms/Distributor';
import { normalizeLink } from '@fhnw/helpers/DesignSystem/normalizeContent';

export interface BlockDataProps extends BlockWrapperDataProps {
  title?: string;
  items?: Content[];
}

interface ViewProps {
  data: BlockDataProps;
  content: Content;
  block: string;
  onChangeBlock: (blockId: string, newData: any) => void;
  isEdit?: boolean;
}

const IGNORED_CONTENT_TYPES = ['File', 'Image', 'Snippet', 'Folder'];

const Factory = (props: PropsWithChildren) => <>{props.children}</>;

const View = (props: ViewProps) => {
  const _content = useSelector(
    (state: { content: { data: Content } }) => state.content.data,
  );
  const content =
    props?.content && (props.content?.['@id'] || props.content?.parent)
      ? props.content
      : _content;
  const data = { ...props?.data };

  let items = data?.items;
  const specific = items && items.length;
  if (!specific) {
    items = content?.items as unknown as Content[];
  }

  const links = [] as { href: string; label: string }[];

  (items || []).forEach((item) => {
    if (!item) {
      return;
    }

    if (
      !specific &&
      (item?.exclude_from_nav ||
        IGNORED_CONTENT_TYPES.includes(item?.['@type']))
    ) {
      return;
    }

    links.push({
      href: normalizeLink(item),
      label: item?.teaser_title || item?.title,
    });
  });

  if (!props?.isEdit && !links.length && !data?.title) {
    return null;
  }

  return (
    <BlockWrapper
      isEdit={props?.isEdit}
      block={props?.block}
      onChangeBlock={props?.onChangeBlock}
      data={data}
      factory={Factory}
    >
      <Distributor title={data?.title || ''} items={links} />
    </BlockWrapper>
  );
};

export default View;
